import { createRequestActionTypes } from '../../helpers'

export const FETCH_SPECS = createRequestActionTypes('SPECS', 'PHONE')



// WEBPACK FOOTER //
// ./src/containers/Specs/constants.js